var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 137,
    viewBox: "0 0 375 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375 56.7213H354.062C333.438 56.7213 291.562 56.7213 250 70.1011C208.438 83.4809 166.562 110.24 125 123.62C83.4375 137 41.5625 137 20.9375 137H0V0H20.9375C41.5625 0 83.4375 0 125 0C166.562 0 208.438 0 250 0C291.562 0 333.438 0 354.062 0H375V56.7213Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeader);
export default __webpack_public_path__ + "static/media/bgHeader.2b968335.svg";
export { ForwardRef as ReactComponent };